class LeanProductLines extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.carousel = this.querySelector('media-carousel');
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.paused = this.motion.matches;
    const update = () => {
      if (!this.carousel.initialized) return;
      const focused = this.contains(document.activeElement);
      const hovered = matchMedia('(hover: hover)').matches && this.matches(':hover');
      if (this.paused || focused || hovered || !this.inView) this.carousel.stop();
      else this.carousel.start();

    };
    const sync = () => {
      const current = this.carousel.currentSlide;
      this.querySelectorAll('media-carousel-slide').forEach(slide => {
        slide.inert = slide !== current;
        slide.setAttribute('aria-hidden', String(slide !== current));
      });
    };
    this.carousel.addEventListener('on:media-carousel:init', () => { sync(); update(); }, options);
    this.carousel.addEventListener('on:media-carousel:slide-change', sync, options);
    this.addEventListener('focusin', update, options);
    this.addEventListener('focusout', () => queueMicrotask(update), options);
    this.addEventListener('mouseenter', update, options);
    this.addEventListener('mouseleave', update, options);
    this.motion.addEventListener('change', () => { this.paused = this.motion.matches; update(); }, options);
    this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; update(); });
    this.observer.observe(this);
    if (this.carousel.initialized) { sync(); update(); }
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
  }
}
if (!customElements.get('lean-product-lines')) customElements.define('lean-product-lines', LeanProductLines);
